import React from 'react'

function UserList() {
    return (
        <div>
            Hi i am user list
        </div>
    )
}

export default UserList
